// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import BasePopUpLayer from "../../../../../engines/components/BasePopUpLayer";
import O1HD from "../../../../../engines/gameEngine";
import data_control from "../../../../../engines/libs/data_control";
import utilsModel from "../../../../../engines/libs/utilsModel";
import { MessageEventKind } from "../../../../define/MessageEventKind";
import NormalGameManager from "../../../manager/NormalGameManager";
import { TouchCardKind } from "./data/TouchCardKind";
import TouchCardDrawBase from "./TouchCardDrawBase";

const {ccclass, property} = cc._decorator;

@ccclass
export default class TouchCardLayerBase extends BasePopUpLayer {

    @property({ type: cc.Node, displayName:'' })
	touchMoveArea: cc.Node = null;

	@property({ type: cc.Node, displayName:'' })
	sprTouchEffect2: cc.Node = null;

	@property({ type: cc.Node, displayName:'' })
	sprTouchEffect1: cc.Node = null;

    @property({ type: cc.Node, displayName:'' })
	nodeVideo: cc.Node = null;

    @property({ type: cc.Node, displayName:'' })
	nodeGold: cc.Node = null;

	@property({ type: cc.Label, displayName:'' })
	labelGold: cc.Label = null;

    @property({ type: cc.Node, displayName:'' })
	nodeTouch: cc.Node = null;

    // @property({ type: cc.Label, displayName:'' })
	// labelPrice: cc.Label = null;

    protected cardTouch: TouchCardDrawBase = null;
    
    private bShowTouchEffect: boolean = false;
    // LIFE-CYCLE CALLBACKS:

    // onLoad () {}

    start() {
        this.cardTouch = this.nodeTouch.getChildByName('TouchCardDrawBase').getComponent(TouchCardDrawBase);
        this.initTouchEvent(this.touchMoveArea);
        this.refreshState();
    }

    resetData() {
        this.bShowTouchEffect = false;
        this.sprTouchEffect1.stopAllActions();
        this.sprTouchEffect2.stopAllActions();
        this.sprTouchEffect1.active = false;
        this.sprTouchEffect2.active = false;
    }

    showEffectAni(bVisible: boolean) {

        // cc.log('v',bVisible)
        if (bVisible) {
            if (this.bShowTouchEffect) {
                return;
            }

            this.sprTouchEffect1.active = true;
            this.sprTouchEffect2.active = true;

            this.sprTouchEffect1.opacity = 0;
            cc.tween(this.sprTouchEffect1)
            .to(0.25, {opacity: 255})
            .to(0.25, {opacity: 0})
            .union()
            .repeatForever()
            .start();

            cc.tween(this.sprTouchEffect2)
            .to(0.01, {scale: 0.6})
            .to(0.14, {opacity: 255})
            .to(0.25, {scale: 1})
            .to(0.14, {opacity: 0})
            .union()
            .repeatForever()
            .start();

        } else {
            this.sprTouchEffect1.active = false;
            this.sprTouchEffect2.active = false;
            this.sprTouchEffect1.stopAllActions();
            this.sprTouchEffect2.stopAllActions();
        }
        this.bShowTouchEffect = bVisible;
    }

    getLotteryInfo() {
        let lotteryInfo: TouchCardKind.ItemInfo = this._carryData.lotteryInfo;
        return lotteryInfo;
    }

    showPrice() {
        let lotteryInfo = this.getLotteryInfo();
        let strPrice = data_control.getNumberFormat(lotteryInfo.price);
        this.labelGold && (this.labelGold.string = strPrice);
        // this.labelPrice && (this.labelPrice.string = '面值' + strPrice);
    }

    touchEventStart(event: cc.Event.EventTouch){
        this.cardTouch.isTouch(event.getLocation());
    }

    touchEventMove(event: cc.Event.EventTouch){
        this.cardTouch.isTouch(event.getLocation());
    }

    touchEventEnd(event: cc.Event.EventTouch){
        this.cardTouch.showEffectAni(false);
    }

    touchEventCancel(event: cc.Event.EventTouch){
        this.cardTouch.showEffectAni(false);
    }

    refreshState() {
        if (!this.nodeVideo) {
            return;
        }
        let lotteryInfo = this.getLotteryInfo();

        let gameData = NormalGameManager._instance.getGameData();
        let count = gameData.curTouchCardNum[lotteryInfo.idx] || 0;
        let bShowVideo = count >= lotteryInfo.limitCount;
        this.nodeVideo.active = bShowVideo;
        this.nodeGold.active = !bShowVideo;
        this.labelGold.node.active = !bShowVideo;
    }

    onClickClose() {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this.destroyNode();
    }

    onClickBuy() {
        O1HD.getManagers().soundMgr.playSound("anNiu");
        if (this.nodeVideo.active) {
            utilsModel.loadAndShowVideoAdTrans(()=>{
                // this.resetStartLottery();
                this.resetData();
                
            },()=>{
                O1HD.getModules().uiControlModule.showMessageBox("观看视频失败");
            },()=>{
    
            },"观看视频获得摸牌玩法次数");
        } else {
            let lotteryInfo = this.getLotteryInfo();
            let needPayPrice : number = lotteryInfo.price;
            if ( O1HD.getServices().userSrv.getCoins() < needPayPrice ) {
                O1HD.getModules().uiControlModule.showMessageBox("金额不足",this.node );
                
                NormalGameManager._instance.openBankPage();
                return;
            }
            O1HD.getServices().userSrv.setCoins( -needPayPrice,true );
            // this.resetStartLottery();
            let gameData = NormalGameManager._instance.getGameData();
            gameData.curTouchCardNum[lotteryInfo.idx] = gameData.curTouchCardNum[lotteryInfo.idx] || 0;
            gameData.curTouchCardNum[lotteryInfo.idx]++;
            NormalGameManager._instance.writeGameData();
            this.refreshState();
            this.resetData();

            O1HD.emit(MessageEventKind.EventName.UPDATE_LOTTERY_LIST);
        } 
    }

    // update (dt) {}
}
